import { loadFullPage } from "./loadFullPage";
import { postFetch } from "./postFetch"; 
import { tomSelectBuscaLocalizacao } from "./eventoBuscarVagaRedirect"; 
import { toastErroCarregar } from "./toastErroCarregar";
import { toastSucesso } from './toastSucesso'
import JustValidate from "just-validate";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";
import { isNullOrEmpty } from "./isNullOrEmpty";
import { inicializarInternacionalizacao } from "../localizacao/alertaVaga/alertaVaga";
import i18next from 'i18next';

export class AlertaVaga {
  constructor(botao) {
    this.botao = botao;
    this.modalGenerico = document.getElementById('modal-generico');
    this.vagaID = this.botao.getAttribute('data-vaga-id');
    this.profissaoID = this.botao.getAttribute('data-profissao-id');
    this.adicionais = this.botao.getAttribute('data-edicao') ?? false;
    this.alertaID = this.botao.getAttribute('data-alerta-id') ?? 0;
    this.localidade = this.botao.getAttribute('data-localidade')?.split('|');
    this.recarregar = this.botao.getAttribute('data-recarregar') == 'true';
    this.cargos = this.botao.getAttribute('data-cargo')?.split('|');

    this.init = this.init.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.excluir = this.excluir.bind(this);
    botao.addEventListener('click', this.init)
  }

  async init() {

    try {
      loadFullPage.mostrar();
      inicializarInternacionalizacao();
      if(!this.cargos)
        this.cargos = "";

      if(!this.alertaID)
        this.alertaID = 0;

      const resultado = await fetch(`/${CULTURE_EMPREGARE}/PainelAlertaVaga/ModalAlerta?id=${this.alertaID}&adicionais=${this.adicionais}&cargo=${this.cargos}`);
      if (!resultado.ok) {
        loadFullPage.esconder();
        toastErroCarregar(i18next.t('ErroGenerico'));
        return;
      }
      
      this.modalGenerico.innerHTML = await resultado.text();
      this.modalGenerico.addEventListener('hidden.bs.modal', () => this.modalGenerico.innerHTML = '');
      this.alertaID = this.modalGenerico.querySelector('#alerta-id-modal')?.value;

      const formValidar = new JustValidate(this.modalGenerico.querySelector('#form-alerta-vaga'), {
        errorFieldCssClass: 'is-invalid',
        focusInvalidField: true,
        lockForm: true
      }); 

      formValidar
        .addField('#CargosAlerta', [{ rule: 'required', errorMessage: i18next.t('ErrorMessageCargo') }])
        // .addField('#CidadeAlerta', [{ rule: 'required', errorMessage: 'Informe pelo menos uma cidade' }])
        .onSuccess(this.submitForm);
      
  
      if ((this.vagaID || this.profissaoID) && !this.alertaID) {
        //this.modalGenerico.querySelector('#container-input-cargos').remove();
        formValidar.removeField('#CargosAlerta');
      }
      

      if (!isNullOrEmpty(this.cargos) && this.cargos.length > 0) {

        // this.modalGenerico.querySelector('#texto-descritivo-alerta').innerHTML = ` de <b> ${this.cargos} </b>`;

        const contagemOptions = this.modalGenerico.querySelector('#container-input-cargos').querySelectorAll(`option`).length;
        
        this.cargos.forEach(value => {
          const option = this.modalGenerico.querySelector(`option[value='${value}']`);
          
          if (option && !option.selected) {
              option.remove();
          }
        });
        
        const html = [];

        for (const cargo of this.cargos) {
          html.push(`<option value="${cargo}" ${contagemOptions > 0 ? '' : 'selected'}>${cargo}</option>`)
        }
  
        this.modalGenerico.querySelector('#CargosAlerta').innerHTML += html;
      }

      if (this.localidade != null && this.localidade.length > 0) {
        const contagemOptions = this.modalGenerico.querySelector('#CidadeAlerta').querySelectorAll(`option`).length;
        
        this.localidade.forEach(value => {
          const option = this.modalGenerico.querySelector(`option[value='${value}']`);
          
          if (option && !option.selected) {
              option.remove();
          }
        });
        
        const html = [];
        for (const cidade of this.localidade) {
          html.push(`<option value="${cidade}" ${contagemOptions > 0 ? '' : 'selected'}>${cidade}</option>`)
        }
  
        this.modalGenerico.querySelector('#CidadeAlerta').innerHTML += html;
      }
      
      import('tom-select').then(({ default: TomSelect }) => {
        new TomSelect('#CargosAlerta', {
          plugins: ['clear_button'],
          maxItems: 5,            
          create: true,              // Cria uma nova opção caso não exista
          persist: false,            // As tags não são “persistidas” como opções fixas
          createOnBlur: true,        // Ao sair do campo, cria a tag com o texto digitado
          searchField: [],
          createFilter: function(input) {
            if (input.length > 150) {
              toastErroCarregar(i18next.t("AlertaVagaErro150Caracteres"));
              return false; // Bloqueia a criação
            }
            return true; // Permite criar
          },
          render: {
            no_results: function(data, escape) {
              // Retorna string vazia para não mostrar "No results found"
              return '';
            },
            option_create: function (data, escape) {
              // somente remove o texto “Add” 
              return `<div class="create"><strong>${escape(data.input)}</strong></div>`;
            }
          },
          onInitialize: function() {
            // Se já existem itens selecionados, remove placeholder
            if (this.getValue().length > 0) {
              this.settings.placeholder = '';
              this.control_input.setAttribute('placeholder', '');
            }

            this.clearOptions();
          },
      
          onChange: function(values) {
            if (values.length > 0) {
              // Remove placeholder
              this.settings.placeholder = '';
              this.control_input.setAttribute('placeholder', '');
            } else {
              // Reexibe placeholder
              this.settings.placeholder = i18next.t('inputCargosPlaceholder');
              this.control_input.setAttribute('placeholder', i18next.t('inputCargosPlaceholder'));
            }
          }
        });
      });

      await tomSelectBuscaLocalizacao('#CidadeAlerta')
      this.modalGenerico.querySelector('#alerta-vaga-excluir')?.addEventListener('click', this.excluir)
      //this.modalGenerico.querySelector('#form-alerta-vaga').addEventListener('submit', this.submitForm);
      
      const isBtnCriarAlerta = this.botao.classList.contains("btn-criar-alerta");

      if ((!this.localidade || this.localidade?.length == 1) && !this.alertaID && !isBtnCriarAlerta) {
        loadFullPage.esconder();
        this.modalGenerico.querySelector('#form-alerta-vaga').dispatchEvent(new Event('submit'));
        return;
      }
      
      this.modalBootstrap = new bootstrap.Modal(this.modalGenerico, { backdrop: "static" });
      
      this.modalBootstrap.show();
      loadFullPage.esconder();
    } catch {
      
      loadFullPage.esconder();
      this.modalBootstrap.hide();
      toastErroCarregar(i18next.t('ErroGenerico'));
    }
  }

  async excluir() {
    Confirm.init({
      className: "confirm-empregare",
      titleColor: "#EA1F1F",
      okButtonColor: "#f8f8f8",
      okButtonBackground: "#EA1F1F",
      cancelButtonColor: "#f8f8f8",
    });

    const callbackSucesso = resultado => {
      
      if (this.recarregar) {
        location.reload();
      }

      this.modalBootstrap.hide();
      loadFullPage.esconder();
      this.botao.dispatchEvent(new Event('alerta-excluido', { bubbles: true }));
      this.alertaID = 0;
      this.adicionais = false;
      this.botao.innerHTML = `<i class="bi bi-bell"></i> ${i18next.t('BtnAtivar')}`;
      this.botao.setAttribute('data-alerta-id', 0);

      toastSucesso(i18next.t('AlertaExcluido'))      
    };

    const callbackErro = resultado => {
      toastErroCarregar(resultado.mensagem);
      loadFullPage.esconder();
      this.modalBootstrap.hide();
    }
  
    Confirm.show(
      i18next.t('ConfirmarExcluirTitulo'),
      i18next.t('ConfirmarExcluirTexto'),
      i18next.t('ConfirmarExcluirBtnConfirmar'),
      i18next.t('ConfirmarExcluirBtnCancelar'),
      async () => {
        loadFullPage.mostrar(i18next.t('ExcluindoAlerta'));
        await postFetch(`/${CULTURE_EMPREGARE}/PainelAlertaVaga/Excluir/${this.alertaID}`, null, callbackSucesso, callbackErro, callbackErro);
      }
    );
  }
  
  async submitForm(event) {
    console.log('event', event);
    
    event.preventDefault();
    loadFullPage.mostrar(i18next.t('LoadSalvandoAlerta'))
    
    const callbackSucesso = resultado => {
      toastSucesso(i18next.t('AlertaSalvo'))      
      if (this.recarregar) {
        location.reload();
      }

      this.modalBootstrap?.hide();
      loadFullPage.esconder();
      this.alertaID = resultado.alertaID;
      this.adicionais = true;
      this.botao.innerHTML = '<i class="bi bi-gear"></i> ' + i18next.t('btnEditar');
      this.botao.setAttribute('data-alerta-id', resultado.alertaID);

      this.botao.dispatchEvent(new Event('alerta-salvo', { bubbles: true }));
    }
  
    const callBackErro = resultado => {
      //this.modalBootstrap?.hide();
      loadFullPage.esconder();
      
      if (resultado?.mensagem != null) {        
        if (resultado.erroAutenticacao) {
          document.querySelector('.btn-login').click();
          return;
        }
        toastErroCarregar(resultado.mensagem);
        return;
      }
      
      toastErroCarregar(i18next.t('ErroGenerico'));
    }
  
    const formData = new FormData(event.target);
  
    formData.append('VagaID', this.vagaID);
    formData.append('ProfissaoID', this.profissaoID);
    formData.append('ID', this.alertaID);

    if (!formData.get('Localidades') && this.localidade) {
      formData.delete('Localidades');
      if(this.profissaoID || this.vagaID){
        for (const localidade of this.localidade) {
          
          formData.append('Localidades', localidade);
        }
      }
    }
    
    if (!formData.get('Cargos') && this.cargos && !isNullOrEmpty(this.cargos)) {
      formData.delete('Cargos');
      for (const cargo of this.cargos) {
        
        formData.append('Cargos', cargo);
      }
    }

    await postFetch(`/${CULTURE_EMPREGARE}/PainelAlertaVaga/Salvar`, formData, callbackSucesso, callBackErro, callBackErro, false, false);
  }
}
